import { CSSProperties } from 'react';
import { Icon, IconName, IconSize, SvgIcon, isSVGIcon } from '@ardoq/icons';

export type EntityIconProps = {
  iconSize?: IconSize;
  imageSrc?: string;
  iconId?: string;
  shapeId?: string;
  color?: string;
  // for backward compability
  style?: CSSProperties;
};

export const EntityIcon = ({
  iconSize = IconSize.MEDIUM,
  imageSrc,
  iconId,
  shapeId,
  color,
  style: propStyle = {},
}: EntityIconProps) => {
  const isFontAwesomeIcon = iconId && !isSVGIcon(iconId);

  const style = {
    ...propStyle,
    minWidth: iconSize,
    width: iconSize,
    height: iconSize,
    color,
  };
  if (imageSrc || isFontAwesomeIcon)
    return (
      <Icon
        style={style}
        src={imageSrc}
        iconName={`fa fa-${iconId}` as IconName}
        iconSize={iconSize}
      />
    );
  if (isSVGIcon(iconId) || shapeId)
    return (
      <SvgIcon
        style={style}
        // SVG icon has higher priority than shape
        iconId={iconId || (shapeId as string)}
        color={color}
      />
    );
  return null;
};
